import React from 'react';
import { useChatPositioning } from '@/hooks/useChatPositioning';
import { useIsMobile } from '@/hooks/use-mobile';
import { cn } from '@/lib/utils';

interface ChatContainerProps {
  children: React.ReactNode;
  chatIndex?: number;
  isMinimized?: boolean;
  isExpanded?: boolean;
  isChatListExpanded?: boolean;
  previousChatStates?: Array<{ isMinimized: boolean; isExpanded?: boolean }>;
  className?: string;
}

export function ChatContainer({ children, chatIndex = 0, isMinimized = false, isExpanded = false, isChatListExpanded = true, previousChatStates = [], className = "" }: ChatContainerProps) {
  const isMobile = useIsMobile();
  const position = useChatPositioning(chatIndex, isMinimized, isExpanded, isChatListExpanded, previousChatStates);

  // Mobile: Full screen positioning with higher z-index, Desktop: Calculated positioning
  if (isMobile) {
    return (
      <div 
        className={cn(
          "fixed inset-0 z-[45] animate-scale-in transition-all duration-300 ease-in-out",
          className
        )}
      >
        {children}
      </div>
    );
  }

  return (
    <div 
      className={cn(
        "fixed animate-scale-in transition-all duration-300 ease-in-out",
        className
      )}
      style={{
        right: position.right,
        bottom: position.bottom,
        zIndex: position.zIndex
      }}
    >
      {isMinimized ? children : <div className="px-3 pt-3">{children}</div>}
    </div>
  );
}